import { axiosWithAuth } from "helpers";

export const creditReviewDetailsService = {
	getMerchantInfo,
	getRiskExposureCalculator,
	updateRiskExposureCalculator,
	getReasonForReviewInfo,
	updateReasonForReviewInfo,
	getExecutiveSignerInfo,
	updateSignerInfo,
	getApprovedParametersInfo,
	getBankStatementsInfo,
	updateBankStatementsInfo,
	getEstimatedExposureInfo,
	getRecommendationInfo,
	updateRecommendationInfo,
	getBusinessReview,
	updateBusinessReview,
	getProductReview,
	updateProductReview,
	getFinancialsInfo,
	updateFinancialsInfo,
	updateCreditReviewToComplete,
	downloadCreditReviewReport,
	getProcessingReview,
};

const API_URL = process.env.REACT_APP_API_URL;

function getMerchantInfo({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/merchant_info`,
	};

	return axiosWithAuth(options);
}

function getRiskExposureCalculator({
	creditReviewId,
}: {
	creditReviewId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/risk_exposure_calculator_info`,
	};

	return axiosWithAuth(options);
}

function updateRiskExposureCalculator(creditReviewId, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/risk_exposure_calculator_info`,
	};

	return axiosWithAuth(options);
}

function getReasonForReviewInfo({
	creditReviewId,
}: {
	creditReviewId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/reason_for_review`,
	};

	return axiosWithAuth(options);
}

function updateReasonForReviewInfo(creditReviewId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/reason_for_review`,
	};

	return axiosWithAuth(options);
}

function getExecutiveSignerInfo({
	creditReviewId,
}: {
	creditReviewId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/signers`,
	};

	return axiosWithAuth(options);
}

function updateSignerInfo(creditReviewId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/signers`,
	};

	return axiosWithAuth(options);
}

function getApprovedParametersInfo({
	creditReviewId,
}: {
	creditReviewId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/approved_parameters`,
	};

	return axiosWithAuth(options);
}

function getBankStatementsInfo({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/bank_statements`,
	};

	return axiosWithAuth(options);
}

function updateBankStatementsInfo(creditReviewId, model) {
	const options = {
		method: "PUT",
		data: model,
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/bank_statements`,
	};

	return axiosWithAuth(options);
}

function getEstimatedExposureInfo({
	creditReviewId,
}: {
	creditReviewId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/estimated_exposure`,
	};

	return axiosWithAuth(options);
}

function getRecommendationInfo({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/recommendation`,
	};

	return axiosWithAuth(options);
}

function updateRecommendationInfo(creditReviewId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/recommendation`,
	};

	return axiosWithAuth(options);
}

function getBusinessReview({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/business_review_message`,
	};

	return axiosWithAuth(options);
}

function updateBusinessReview(creditReviewId, data) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/business_review_message`,
		data,
	};

	return axiosWithAuth(options);
}

function getProductReview({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/product_review`,
	};

	return axiosWithAuth(options);
}

function updateProductReview(creditReviewId, data) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/product_review`,
		data,
	};

	return axiosWithAuth(options);
}

function getFinancialsInfo({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/financials`,
	};

	return axiosWithAuth(options);
}

function updateFinancialsInfo(creditReviewId, data) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/financials`,
		data,
	};

	return axiosWithAuth(options);
}

function updateCreditReviewToComplete(creditReviewId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/complete`,
	};

	return axiosWithAuth(options);
}

function downloadCreditReviewReport(creditReviewId, token) {
	const url = `${API_URL}/api/credit_reviews/${creditReviewId}/report?token=${token}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function getProcessingReview({ creditReviewId }: { creditReviewId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/credit_reviews/${creditReviewId}/processing_review`,
	};

	return axiosWithAuth(options);
}
